export interface IMiscStore {
  loading: boolean;
  notification: { status: boolean; message: string; type: any };
}

export const miscStore = {
  loading: false,
  notification: { status: false, message: '', type: 'error' },
};
